import { useState, useEffect } from "react";
import { IoPeopleOutline } from "react-icons/io5";
import { getAccountParentsInfoAsync } from "./../../../../../services/accountService";
import DescriptionList from "../../../../../components/common/DescriptionList";
import _ from "lodash";
import Modal from "../../../../../components/common/Modal";
import ParentsForm from "./ParentsForm";

const ParentsInformation = ({ id }) => {
  const [parents, setParents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchParents = async () => {
      setIsLoading(true);
      const result = await getAccountParentsInfoAsync(id);

      if (mounted) {
        setParents(result);
        setIsLoading(false);
      }
    };

    fetchParents();

    return () => {
      mounted = false;
    };
  }, [id, refresh]);

  const mother = !_.isEmpty(parents)
    ? `${parents[0].last_name}, ${parents[0].first_name} ${parents[0].middle_name}`
    : "-";

  const father = !_.isEmpty(parents)
    ? `${parents[1].last_name}, ${parents[1].first_name} ${parents[1].middle_name}`
    : "-";

  const handleSuccess = () => {
    setShowForm(false);
    setRefresh(!refresh);
  };

  return (
    <div className="p-5">
      <div className="mt-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IoPeopleOutline className="mr-3 text-3xl text-gray-300" />
            <div>
              <p className="text-gray-500">Parents Information</p>
              <span className="text-xs text-gray-400">Parent Details</span>
            </div>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <div className="px-12 py-5 space-y-7">
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Mother's Maiden Name"
            className="col-span-2 sm:col-span-1"
            content={mother}
            isLoading={isLoading}
          />
          <DescriptionList
            label="Father's Name"
            className="col-span-2 sm:col-span-1"
            content={father}
            isLoading={isLoading}
          />
        </div>
      </div>
      <Modal
        title="Parents Information"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <ParentsForm
          id={id}
          data={parents}
          isLoading={isFormLoading}
          setLoading={setIsFormLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default ParentsInformation;
